import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/Loader"; // Ensure the correct path
import { useNavigate } from "react-router-dom";
import Calling from "../../api/Calling";

export default function ForgetPw() {
    const [loader, setLoader] = useState(false);
    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        setLoader(true);
        e.preventDefault();
        const body = {
            a_email: email
        }
        try {
            const resp = await Calling.ForgetPw(body); // Example function, replace with actual
            const { status, message, token } = resp;
            if (status) {
                toast.success(message, {
                    autoClose: 2000,
                });
                localStorage.setItem('forgetPw', token);
                navigate("/admin/panel/forget/otp"); // Replace with the actual route
            } else {
                toast.error(message, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            navigate('/Error');
        } finally {
            setLoader(false);
        }
        // Replace with your OTP verification logic

    };

    return (
        <>
            {loader && <Loader />}

            <div className="min-h-screen flex items-center w-full justify-center back-Img">

                <title>Email Verification</title>
                <div className="bg-main-white p-8 rounded-lg shadow-md w-full max-w-md">
                    <h1 className="text-2xl font-bold text-primary-purple mb-6 text-center">
                        Email Verification
                    </h1>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-6">
                            <label htmlFor="email" className="block text-primary-blue">
                                Enter Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full p-2 border border-main-border rounded mt-1  focus:ring-2 focus:ring-main-subfont  focus:outline-none"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-primary-blue text-main-white py-2 px-4 rounded hover:bg-primary-purple focus:outline-none focus:ring-2 focus:ring-primary-purple"
                        >
                            Verify OTP
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
}

// Example function for OTP verification

